module.exports = __webpack_public_path__ + "static/media/e-golf.122e5fdb.png";